import apiClient, { unwrap } from './client'
import type { Stats } from './types'

export const statsApi = {
  get() {
    return unwrap<Stats>(apiClient.get('/stats'))
  },
}
